<template>
  <div>
    <!-- Marquee header commented out -->
    <!-- <vue-marquee-slider id="marquee-slider" :speed="10000" :width="1000">
      <div id="marquee-item">
        <img
          :src="require('@/assets/images/rocket-marquee.png')"
          style="height: 25px;margin-right: 10px;"
        />
        <div>
          Use the Coupon <b>UPSKOOL20</b> to get
          <b style="color: yellow;">20% off</b> on your first purchase
        </div>
        <img
          :src="require('@/assets/images/giftbox-marquee.png')"
          style="height: 20px;margin-left: 10px;"
        />
      </div>
    </vue-marquee-slider> -->

    <nav
      class="navbar has-shadow"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-content">
        <a href="/" class="navbar-item">
          <img
            class="logo"
            :src="require('@/assets/images/UP_SKOOL_LOGO.png')"
            alt="Up-skool Logo"
          />
        </a>

        <div class="navbar-end">
          <div class="navbar-item" v-if="getUserSchoolName">
            <span class="school-name">{{ getUserSchoolName }}</span>
          </div>

          <b-dropdown 
            append-to-body
            aria-role="menu"
            position="is-bottom-left"
            :mobile-modal="false"
          >
            <template #trigger>
              <a class="navbar-link" role="button">
                <span>{{ getUserName }}</span>
              </a>
            </template>

            <b-dropdown-item custom aria-role="listitem">
              <a 
                @click="$router.push({ name: 'profile' })" 
                class="dropdown-link"
              >
                <b-icon icon="account" size="is-small"></b-icon>
                <span class="ml-2">My Profile</span>
              </a>
            </b-dropdown-item>

            <b-dropdown-item custom aria-role="listitem">
              <a 
                @click="$router.push({ name: 'billing' })" 
                class="dropdown-link"
              >
                <b-icon icon="credit-card" size="is-small"></b-icon>
                <span class="ml-2">Billing</span>
              </a>
            </b-dropdown-item>

            <hr class="dropdown-divider">

            <b-dropdown-item custom aria-role="listitem">
              <a 
                @click="logout()" 
                class="dropdown-link"
              >
                <b-icon icon="logout" size="is-small"></b-icon>
                <span class="ml-2">Logout</span>
              </a>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "HeaderComponent",
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getUserSchoolName",
      "getUserName",
      "getUserDepartment",
      "getUserType",
      "fetchMenu",
      "fetchAdministratorMenu",
      "getUserSchoolName",
    ]),
    showMenu() {
      if (this.getUserType == "T") return this.fetchMenu;
      else if (this.getUserType == "A") return this.fetchAdministratorMenu;

      //If nothing is true return nothing
      return [];
    },
  },
  methods: {
    ...mapActions(["logoutUser"]),
    logout() {
      const loginRoute = this.getUserSchoolName ? "login-school" : "login";
      this.logoutUser();
      this.$router.push({ name: loginRoute });
    },
  },
};
</script>
<style scoped>
nav {
  height: 5rem;
}

.navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 2rem;
}

.navbar-item {
  display: flex;
  align-items: center;
  border: none !important;
}

.logo {
  height: 3rem;
  width: auto;
  object-fit: contain;
}

.navbar-end {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.school-name {
  color: #666;
  font-weight: 500;
}

.navbar-link {
  color: #333;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.navbar-link:hover {
  background-color: #f8f9fa;
  color: #8919e7;
}

.dropdown-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  color: #333;
  text-decoration: none;
  transition: all 0.2s ease;
  width: 100%;
}

.dropdown-link:hover {
  background-color: #f8f9fa;
  color: #8919e7;
  text-decoration: none;
}

.dropdown-divider {
  margin: 0.5rem 0;
  border-color: #e5e5e5;
}

#marquee-slider {
  background-color: rgb(116, 9, 255);
  padding: 5px 0;
}

#marquee-item {
  display: flex;
  align-items: center;
  color: #ffffff;
}
</style>
